import type { ReactNode } from "react";

import { DeleteDialog as DSDeleteDialog } from "@eisox/design-system";
import { BinIcon } from "@eisox/icons";

import { m } from "~/paraglide/messages";

interface DeleteDialogProps
  extends
    Omit<DSDeleteDialog.RootProps, "children">,
    Pick<DSDeleteDialog.ContentProps, "title" | "className" | "onDelete"> {
  description?: ReactNode;
  validator?: boolean;
  children?: ReactNode;
}

export const DeleteDialog: React.FC<DeleteDialogProps> = ({
  title,
  className,
  description,
  validator = true,
  onDelete,
  children,
  ...rootProps
}) => (
  <DSDeleteDialog.Root {...rootProps}>
    {children && <DSDeleteDialog.Trigger asChild>{children}</DSDeleteDialog.Trigger>}
    <DSDeleteDialog.Content
      title={title}
      icon={<BinIcon className="text-primary-red" />}
      className={className}
      cancelLabel={m.cancel()}
      deleteLabel={m.delete()}
      onDelete={onDelete}
    >
      {description}
      {validator && <DSDeleteDialog.Validator label={m.code()} placeholder={m.enter_code()} />}
    </DSDeleteDialog.Content>
  </DSDeleteDialog.Root>
);

DeleteDialog.displayName = "DeleteDialog";
